import InfoCircleOutlineIcon from "@modules/icons/registry/funbank/info-circle-outline";
import ArrowsLeftRightIcon from "@modules/icons/registry/funbank/arrows-left-right";
import ArrowsUpDownIcon from "@modules/icons/registry/funbank/arrows-up-down";
import CheckIcon from "@modules/icons/registry/funbank/check";
import ChevronLeftIcon from "@modules/icons/registry/funbank/chevron-left";
import ChevronRightIcon from "@modules/icons/registry/funbank/chevron-right";
import ChevronDownIcon from "@modules/icons/registry/funbank/chevron-down";
import FacebookIcon from "@modules/icons/registry/funbank/facebook";
import FacebookFilledIcon from "@modules/icons/registry/funbank/facebook-filled";
import GoogleFilledIcon from "@modules/icons/registry/funbank/google-filled";
import HeadsetIcon from "@modules/icons/registry/funbank/headset";
import InstagramIcon from "@modules/icons/registry/funbank/instagram";
import InsuranceShieldCheckIcon from "@modules/icons/registry/funbank/insurance-shield-check";
import LuggageIcon from "@modules/icons/registry/funbank/luggage";
import LuggageHandIcon from "@modules/icons/registry/funbank/luggage-hand";
import MailIcon from "@modules/icons/registry/funbank/mail";
import MoneySymbolIcon from "@modules/icons/registry/funbank/money-symbol";
import TrashIcon from "@modules/icons/registry/funbank/trash";
import PersonIconRound from "@modules/icons/registry/funbank/person-icon-round";
import Sunset from "@modules/icons/registry/funbank/sunset";
import Sunrise from "@modules/icons/registry/funbank/sunrise";
import MapIcon from "@modules/icons/registry/funbank/map";
import SuitCase from "@modules/icons/registry/funbank/suit-case";
import StarFilledIcon from "@modules/icons/registry/funbank/star-filled";
import HomeIcon from "@modules/icons/registry/funbank/home";
import AirplaneIcon from "@modules/icons/registry/funbank/airplane";
import StarEmptyIcon from "@modules/icons/registry/funbank/star-empty";
import TachometerIcon from "@modules/icons/registry/funbank/car-tachometer";
import CarDoorIcon from "@modules/icons/registry/funbank/car-door";
import StarHalfFilledIcon from "@modules/icons/registry/funbank/star-half-filled";
import AcIcon from "@modules/icons/registry/funbank/ac";
import WifiIcon from "@modules/icons/registry/funbank/wifi";
import FoodIcon from "@modules/icons/registry/funbank/food";
import PoolIcon from "@modules/icons/registry/funbank/pool";
import CreditCardIcon from "@modules/icons/registry/funbank/credit-card";
import AccountIcon from "@modules/icons/registry/funbank/account";
import AirlineSeat from "@modules/icons/registry/funbank/airline-seat";
import { ArrowDownIcon } from "@modules/icons/registry/funbank/arrow-down";
import ArrowLeftIcon from "@modules/icons/registry/funbank/arrow-left";
import ArrowRightIcon from "@modules/icons/registry/funbank/arrow-right";
import { ArrowUpIcon } from "@modules/icons/registry/funbank/arrow-up";
import BedIcon from "@modules/icons/registry/funbank/bed";
import BookIcon from "@modules/icons/registry/funbank/book";
import CalendarFillIcon from "@modules/icons/registry/funbank/calendar-fill";
import CarIcon from "@modules/icons/registry/funbank/car";
import CarTransmissionIcon from "@modules/icons/registry/funbank/car-transmission";
import CartIcon from "@modules/icons/registry/funbank/cart";
import ChevronUpIcon from "@modules/icons/registry/funbank/chevron-up";
import CircleCheckIcon from "@modules/icons/registry/funbank/circle-check";
import CircleExclamationIcon from "@modules/icons/registry/funbank/circle-exclamation";
import CircleFilledCheckIcon from "@modules/icons/registry/funbank/circle-filled-check";
import CircleFilledExclamationIcon from "@modules/icons/registry/funbank/circle-filled-exclamation";
import CirclePlusIcon from "@modules/icons/registry/funbank/circle-plus";
import CircleXIcon from "@modules/icons/registry/funbank/circle-x";
import ClockFilledIcon from "@modules/icons/registry/funbank/clock-filled";
import ClockOutlineIcon from "@modules/icons/registry/funbank/clock-outline";
import ColumnIcon from "@modules/icons/registry/funbank/column";
import CrossIcon from "@modules/icons/registry/funbank/cross";
import CurrenciesIcon from "@modules/icons/registry/funbank/currencies";
import GlobeIcon from "@modules/icons/registry/funbank/globe";
import DeleteIcon from "@modules/icons/registry/funbank/delete";
import DiscountTagFill from "@modules/icons/registry/funbank/discount-tag-fill";
import EditIcon from "@modules/icons/registry/funbank/edit";
import EmailIcon from "@modules/icons/registry/funbank/email";
import ErrorOutlinedIcon from "@modules/icons/registry/funbank/error-outlined";
import GridIcon from "@modules/icons/registry/funbank/grid";
import HeartOutlinedIcon from "@modules/icons/registry/funbank/heart-outlined";
import HeartIcon from "@modules/icons/registry/funbank/heart";
import HotelIcon from "@modules/icons/registry/funbank/hotel";
import PlaneIcon from "@modules/icons/registry/funbank/plane";
import VehicleIcon from "@modules/icons/registry/funbank/vehicle";
import InfoIcon from "@modules/icons/registry/funbank/info";
import InputCheckIcon from "@modules/icons/registry/funbank/input-check-radio";
import LinkedingIcon from "@modules/icons/registry/funbank/linkedin";
import MapPin2Icon from "@modules/icons/registry/funbank/map-pin2";
import MapPin from "@modules/icons/registry/funbank/map-pin";
import PercentIcon from "@modules/icons/registry/funbank/percent";
import PersonIconFilled from "@modules/icons/registry/funbank/person-filled";
import PhotosIcon from "@modules/icons/registry/funbank/photos";
import PlaneLand from "@modules/icons/registry/funbank/plane-land";
import PlaneTake from "@modules/icons/registry/funbank/plane-take";
import PlusCircleFilledIcon from "@modules/icons/registry/funbank/plus-circle-filled-icon";
import Plus from "@modules/icons/registry/funbank/plus";
import QuestionMarkCircleIcon from "@modules/icons/registry/funbank/question-mark-circle";
import SandClockIcon from "@modules/icons/registry/funbank/sand-clock";
import SearchIcon from "@modules/icons/registry/funbank/search";
import ShieldCheckFillIcon from "@modules/icons/registry/funbank/shield-check-fill";
import ShoppingBagIcon from "@modules/icons/registry/funbank/shopping-bag";
import Spinner from "@modules/icons/registry/funbank/spinner";
import Sun from "@modules/icons/registry/funbank/sun";
import TagFillIcon from "@modules/icons/registry/funbank/tag-fill";
import TelephoneIcon from "@modules/icons/registry/funbank/telephone";
import TelephoneFillIcon from "@modules/icons/registry/funbank/telephone-fill";
import ClockIcon from "@modules/icons/registry/funbank/clock";
import CalendarIcon from "@modules/icons/registry/funbank/calendar";
import CalendarOutlineIcon from "@modules/icons/registry/funbank/calendar-outline";
import BeachIcon from "@modules/icons/registry/funbank/beach";
import CityIcon from "@modules/icons/registry/funbank/city";
import MountainIcon from "@modules/icons/registry/funbank/mountain";
import DiscountIcon from "@modules/icons/registry/funbank/discount";
import CountryIcon from "@modules/icons/registry/funbank/country";
import LocationPinIcon from "@modules/icons/registry/funbank/location-pin";
import AirplaneFromTopIcon from "@modules/icons/registry/funbank/airplane-from-top";
import AirplaneToRightIcon from "@modules/icons/registry/funbank/airplane-to-right";
import AirplaneFillTopIcon from "@modules/icons/registry/funbank/airplane-fill-top";
import ParkingIcon from "@modules/icons/registry/funbank/parking";
import CateringIcon from "@modules/icons/registry/funbank/catering";
import WaterParkIcon from "@modules/icons/registry/funbank/water-park";
import ChargingStationIcon from "@modules/icons/registry/funbank/charging-station";
import AmenityIcon from "@modules/icons/registry/funbank/amenity";
import HotelsDiscountIcon from "@modules/icons/registry/funbank/hotels-discount";
import MoonStarsIcon from "@modules/icons/registry/funbank/moon-stars";
import CirclePlusOutlineIcon from "@modules/icons/registry/funbank/circle-plus-outline";
import MinusCircleFilledIcon from "@modules/icons/registry/funbank/minus-circle-filled";
import InfoCardInfoIcon from "@modules/icons/registry/funbank/info-card-info";
import CircleXFilledIcon from "@modules/icons/registry/funbank/circle-x-filled";
import TriangleFilledExclamationIcon from "@modules/icons/registry/funbank/triangle-filled-exclamation";
import CircleLogoutIcon from "@modules/icons/registry/funbank/circle-logout";
import CheckboxOutlineIcon from "@modules/icons/registry/funbank/checkbox-outline";
import CheckboxBaseIcon from "@modules/icons/registry/funbank/checkbox-base";
import VcardIcon from "@modules/icons/registry/funbank/vcard";
import ArrowLeftLittleIcon from "@modules/icons/registry/funbank/arrow-left-little";
import ArrowRightSmallIcon from "@modules/icons/registry/funbank/arrow-right-small";
import ContactIcon from "@modules/icons/registry/funbank/contact";
import TermsIcon from "@modules/icons/registry/funbank/terms";
import PrivacyIcon from "@modules/icons/registry/funbank/privacy";
import LocationPinFillIcon from "@modules/icons/registry/funbank/location-pin-fill";
import BackArrowIcon from "@modules/icons/registry/funbank/back-arrow";
import BackArrowMobileIcon from "@modules/icons/registry/funbank/back-arrow-mobile";
import ChevronLeftRightIcon from "@modules/icons/registry/funbank/chevron-left-right";
import XIcon from "@modules/icons/registry/funbank/x";
import CarTypeIcon from "@modules/icons/registry/funbank/car-type";
import HomeFlightIcon from "@modules/icons/registry/funbank/home-flight-icon";
import HomeCarIcon from "@modules/icons/registry/funbank/home-car-icon";
import HomeHotelIcon from "@modules/icons/registry/funbank/home-hotel-icon";
import HomeRetailIcon from "@modules/icons/registry/funbank/home-retail-icon";
import CheckBoxCheckIcon from "@modules/icons/registry/funbank/checkbox-check";
import VisibilityOnIcon from "@modules/icons/registry/funbank/visibility-on";
import VisibilityOffIcon from "@modules/icons/registry/funbank/visibility-off";
import AddCard from "@modules/icons/registry/funbank/addCard";
import HeaderUserIcon from "@modules/icons/registry/funbank/header-user-icon";
import ProfileUserIcon from "@modules/icons/registry/funbank/profile-user-icon";
import EditProfileIcon from "@modules/icons/registry/funbank/edit-profile";
import FrequentFlyerIcon from "@modules/icons/registry/funbank/frequent-flyer";
import PromoAirplaneIcon from "@modules/icons/registry/funbank/promo-airplane";
import PromoBedIcon from "@modules/icons/registry/funbank/promo-bed";
import PromoWebIcon from "@modules/icons/registry/funbank/promo-web";
import PromoRestaurantIcon from "@modules/icons/registry/funbank/promo-restaurant";
import PaymentAvailablePointsIcon from "@modules/icons/registry/funbank/payment-available-points";
import ArrowsLeftRightBorderlessIcon from "@modules/icons/registry/funbank/arrows-left-right-borderless";
const FunbankIconsConfig = {
  beach: BeachIcon,
  city: CityIcon,
  mailFill: MailIcon,
  mountain: MountainIcon,
  discount: DiscountIcon,
  country: CountryIcon,
  chevronLeft: ChevronLeftIcon,
  chevronRight: ChevronRightIcon,
  chevronUp: ChevronUpIcon,
  chevronDown: ChevronDownIcon,
  chevronLeftRight: ChevronLeftRightIcon,
  arrowUp: ArrowUpIcon,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowsLeftRight: ArrowsLeftRightIcon,
  arrowsUpDown: ArrowsUpDownIcon,
  locationPin: LocationPinIcon,
  //googleMapPin: GoogleMapPinIcon,
  map: MapIcon,
  mapPin: MapPin,
  mapPin2: MapPin2Icon,
  airplane: AirplaneIcon,
  airplaneFromTop: AirplaneFromTopIcon,
  airplaneToRight: AirplaneToRightIcon,
  airplaneFillTop: AirplaneFillTopIcon,
  plane: PlaneIcon,
  planeLand: PlaneLand,
  planeTake: PlaneTake,
  car: CarIcon,
  carType: CarTypeIcon,
  hotel: HotelIcon,
  carDoor: CarDoorIcon,
  carTransmission: CarTransmissionIcon,
  carTachometer: TachometerIcon,
  airlineSeat: AirlineSeat,
  vehicle: VehicleIcon,
  home: HomeIcon,
  bed: BedIcon,
  ac: AcIcon,
  wifi: WifiIcon,
  parking: ParkingIcon,
  pool: PoolIcon,
  catering: CateringIcon,
  food: FoodIcon,
  waterPark: WaterParkIcon,
  chargingStation: ChargingStationIcon,
  amenity: AmenityIcon,
  discountTagFill: DiscountTagFill,
  hotelsDiscount: HotelsDiscountIcon,
  luggage: LuggageIcon,
  luggageHand: LuggageHandIcon,
  suitCase: SuitCase,
  calendar: CalendarIcon,
  calendarFill: CalendarFillIcon,
  calendarOutLine: CalendarOutlineIcon,
  clock: ClockIcon,
  clockOutline: ClockOutlineIcon,
  clockFilled: ClockFilledIcon,
  sun: Sun,
  sunSet: Sunset,
  sunRise: Sunrise,
  moonStars: MoonStarsIcon,
  check: CheckIcon,
  plus: Plus,
  percent: PercentIcon,
  inputCheck: InputCheckIcon,
  circleCheck: CircleCheckIcon,
  circlePlus: CirclePlusIcon,
  circleX: CircleXIcon,
  circleExclamation: CircleExclamationIcon,
  circleFilledExclamation: CircleFilledExclamationIcon,
  circleFilledCheck: CircleFilledCheckIcon,
  plusCircleFilled: PlusCircleFilledIcon,
  minusCircleFilled: MinusCircleFilledIcon,
  circlePlusOutline: CirclePlusOutlineIcon,
  info: InfoIcon,
  infoCircleOutlineIcon: InfoCircleOutlineIcon,
  star: StarFilledIcon,
  starHalfFilled: StarHalfFilledIcon,
  starFilled: StarFilledIcon,
  starEmpty: StarEmptyIcon,
  moneySymbol: MoneySymbolIcon,
  insuranceShieldCheck: InsuranceShieldCheckIcon,
  trash: TrashIcon,
  credit_card: CreditCardIcon,
  cart: CartIcon,
  photos: PhotosIcon,
  column: ColumnIcon,
  grid: GridIcon,
  cross: CrossIcon,
  heart: HeartIcon,
  heartOutlined: HeartOutlinedIcon,
  globe: GlobeIcon,
  delete: DeleteIcon,
  edit: EditIcon,
  errorOutlined: ErrorOutlinedIcon,
  questionMarkCircle: QuestionMarkCircleIcon,
  sandClock: SandClockIcon,
  search: SearchIcon,
  shieldCheckFill: ShieldCheckFillIcon,
  shoppingBag: ShoppingBagIcon,
  spinner: Spinner,
  tagFill: TagFillIcon,
  telephone: TelephoneIcon,
  telephoneFill: TelephoneFillIcon,
  warning: ErrorOutlinedIcon,
  warningFill: ErrorOutlinedIcon,
  visibilityOff: VisibilityOffIcon,
  visibilityOn: VisibilityOnIcon,
  menu: CrossIcon,
  xIcon: XIcon,
  trashcan: TrashIcon,
  trashcanV2: TrashIcon,
  weight: Plus,
  person: PersonIconRound,
  personIconFilled: PersonIconFilled,
  personIconRound: PersonIconRound,
  headset: HeadsetIcon,
  mail: MailIcon,
  book: BookIcon,
  account: AccountIcon,
  currencies: CurrenciesIcon,
  email: EmailIcon,
  user: PersonIconRound,
  userFill: PersonIconFilled,
  facebook: FacebookIcon,
  facebookFilled: FacebookFilledIcon,
  googleFilled: GoogleFilledIcon,
  instagram: InstagramIcon,
  linkedin: LinkedingIcon,
  infoCardInfo: InfoCardInfoIcon,
  circleXFilled: CircleXFilledIcon,
  triangleFilledExclamation: TriangleFilledExclamationIcon,
  circleLogout: CircleLogoutIcon,
  checkboxOutline: CheckboxOutlineIcon,
  checkboxBase: CheckboxBaseIcon,
  vcard: VcardIcon,
  arrowLeftLittle: ArrowLeftLittleIcon,
  arrowRightSmall: ArrowRightSmallIcon,
  contact: ContactIcon,
  terms: TermsIcon,
  privacy: PrivacyIcon,
  locationPinFill: LocationPinFillIcon,
  backArrow: BackArrowIcon,
  backArrowMobile: BackArrowMobileIcon,
  homeFlightIcon: HomeFlightIcon,
  homeHotelIcon: HomeHotelIcon,
  homeCarIcon: HomeCarIcon,
  homeRetailIcon: HomeRetailIcon,
  checkboxCheck: CheckBoxCheckIcon,
  flightpricedRecommendationCardTypeIcon: AirplaneIcon,
  hotelPricedRecommendationCardTypeIcon: HomeIcon,
  historyFlightIcon: HomeFlightIcon,
  historyHotelIcon: HomeHotelIcon,
  historyCarIcon: HomeCarIcon,
  selectedFlightIcon: AirplaneIcon,
  addCardIcon: AddCard,
  headerUserIcon: HeaderUserIcon,
  profileUserIcon: ProfileUserIcon,
  editProfileIcon: EditProfileIcon,
  frequentFlyerIcon: FrequentFlyerIcon,
  promoAirplaneIcon: PromoAirplaneIcon,
  promoBedIcon: PromoBedIcon,
  promoWebIcon: PromoWebIcon,
  promoRestaurantIcon: PromoRestaurantIcon,
  paymentAvailablePointsIcon: PaymentAvailablePointsIcon,
  arrowsLeftRightBorderlessIcon: ArrowsLeftRightBorderlessIcon
};
export default FunbankIconsConfig;